import React from 'react'
import { RouteConstants } from '../../navigation/navigation-types'
import { removeUser } from '../../storages/user'
import { supabase } from '../../lib/supabase'

const Logout = () => {
    React.useEffect(() => {
        supabase.auth.signOut().finally(() => {
            removeUser()
            window.location.href = RouteConstants.home
        })
    }, [])

    return (
        <div>Probíhá odhlašování</div>
    )
}

export default Logout
